// extracted by mini-css-extract-plugin
export default {"list":"wh4iu2","item":"xOJf0w","icon":"BLR3Zr","caption":"JUMr5V"};